import css from './index.module.scss';
import { FormatMoney } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import SVGLogo from '@/components/UI/svg/corporate-pruchase/template/SVGLogo';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

export default function Template({ obj, langeKey, isHideSeal }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang(langeKey || 'corporatepurchase.template');

    return (
        <div className={`template ${css.template}`}>
            <div className="template-header">
                <div className="logo">
                    <SVGLogo />
                </div>
                <div className="line"></div>
            </div>
            <p className="template-title">{t('title')}</p>
            <div className="series-number">
                <p className="s-number">{obj?.seqNumber}</p>
                <p className="date">{obj?.date}</p>
            </div>
            <div className="company-name">{`${obj?.name}　${obj?.personType}`}</div>
            <div className="ecoflow-info">
                {!isHideSeal && (
                    <div className="seal">
                        <img className="seal-img" src={handleDynamicPath('/media/corporate-purchase/seal.png')} alt={t('ecoflow')} aria-label={t('ecoflow')} />
                    </div>
                )}
                <div className="info">
                    <p className="ecoflow">{t('ecoflow')}</p>
                    <p className="zip">{t('zip')}</p>
                    <p className="address">{t('address')}</p>
                    <p className="tel">{obj?.tel || t('tel')}</p>
                    <p className="tel register-number">{t('register_number')}</p>
                </div>
            </div>
            <p className="template-desc">{t('desc')}</p>
            <div className="template-table">
                <div className="total-money">
                    <span className="total">{t('total_money')}</span>
                    <span className="t-number">
                        {t('unit')} {FormatMoney(obj?.sumTotalPrice)} {t('tax_include')}
                    </span>
                </div>
                <p className="t-line"></p>
                <p className="t-line"></p>
                <div className="table-content">
                    <div className="table-inner">
                        <div className="t-th">
                            <div className="t-td">{t('product')}</div>
                            <div className="t-td">{t('price')}</div>
                            <div className="t-td">{t('number')}</div>
                            <div className="t-td">{t('money')}</div>
                        </div>
                        {obj?.productItems?.length > 0 &&
                            (obj?.productItems?.length < 10
                                ? [...obj?.productItems, ...new Array(10 - obj?.productItems?.length).fill({})]
                                : obj?.productItems
                            ).map((list: any, k: number) => (
                                <div className="t-tr" key={k}>
                                    <div className="t-td">{list?.title}</div>
                                    <div className="t-td">
                                        {list?.price && t('unit')} {FormatMoney(list?.compareAtPrice)}
                                    </div>
                                    <div className="t-td">{list?.quantity}</div>
                                    <div className="t-td">
                                        {list?.price && t('unit')} {FormatMoney(list?.compareAtTotalPrice)}
                                    </div>
                                </div>
                            ))}
                    </div>
                    <div className={`other-info ${obj?.productItems?.length < 10 ? 'double' : obj?.productItems?.length % 2 === 1 ? 'single' : 'double'}`}>
                        <div className="other-info-inner">
                            <div className="dicount-box">
                                <span className="discount-label">{t('discount')}</span>
                                <span className="discount-value">
                                    {`${Number(obj?.discountTotalPrice) !== 0 ? '- ' : ''}${t('unit')}`} {FormatMoney(obj?.discountTotalPrice)}
                                </span>
                            </div>
                            <div className="total-box">
                                <span className="total-label">{t('total')}</span>
                                <span className="total-value">
                                    {t('unit')} {FormatMoney(obj?.subTotalPrice)}
                                </span>
                            </div>
                            <div className="ship-box">
                                <span className="ship-label">{t('ship')}</span>
                                <span className="ship-value">
                                    {t('unit')} {FormatMoney(obj?.shippingPrice)}
                                </span>
                            </div>
                            <div className="tax-box">
                                <span className="tax-tip">
                                    {t('tax_tip')} {t('unit')} {FormatMoney(obj?.subTotalPrice)}
                                </span>
                                <span className="tax-label">{t('tax')}</span>
                                <span className="tax-value">
                                    {t('unit')} {FormatMoney(obj?.subTotalPrice - Math.round(obj?.subTotalPrice / 1.1))}
                                </span>
                            </div>
                            <div className="sum-box">
                                <span className="sum-label">{t('sum_money')}</span>
                                <span className="sum-value">
                                    {t('unit')} {FormatMoney(obj?.sumTotalPrice)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <p className="template-memo">{t('memo')}</p>
            </div>
        </div>
    );
}
